import React, { Component } from 'react';
import { List, Pagination, Button, Row } from 'antd';
import { app, api } from "../../../app";

class TeamPublic extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            teamno: props.match.params.teamno,
            teamname: "正在加载 ... "
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true });
        let { teamno } = this.state,
            params = {
                page,
                teamno,
                request: "team",
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total, teamname } = await app.post(api.TeamOpenList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(total || 0) });
        }
    };

    handleToDetail = (id) => {
        this.props.history.push('/ranks/public/detail/' + id);
    }

    render () {
        let { data_loading, teamname, dataList, total, page } = this.state;
        return (
            <div className="dynamic-page">
                <Row className="dynamic-title" type="flex" justify="space-between">
                    <span>队伍公开</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="dp-content">
                    <div className="dp-title">{teamname}</div>
                    <List
                        itemLayout="vertical"
                        locale={app.tbLocale(data_loading)}
                        loading={data_loading}
                        className="dp-list"
                        dataSource={dataList}
                        renderItem={item => (
                            <List.Item
                                onClick={() => this.handleToDetail(item.id)}
                                key={item.id}
                                extra={item.submit_time}
                                className="dp-row"
                            >{item.open_title}</List.Item>
                        )}
                    />
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
            </div>
        );
    }
}

export default TeamPublic;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamPublic.jsx